/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _get from 'lodash/get'

export enum PartyGalaTimeStatus {
  待开始 = 1,
  进行中 = 2,
  已结束 = 3,
}

export enum PartyGalaStatus {
  全部 = 0,
  已取消 = 20,
  已驳回 = 30,
  房间自制 = 110,
  已通过 = 120,
  精选 = 130,
  平台推荐 = 140,
  官方推荐 = 150,
}

export const gala_cancel = createAsyncThunk(
  'PartyGala/gala_cancel',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_cancel',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const gala_change_time = createAsyncThunk(
  'PartyGala/gala_change_time',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_change_time',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const gala_detail = createAsyncThunk(
  'PartyGala/gala_detail',
  async (params: any, store: any) => {
    const {
      deviceinfo: {h_web_room_id},
      otherInfo: {from = '', is_old_activity = ''},
    } = store.getState().env
    const resp = await http.post(
      '/live/misc/gala_list',
      {
        from,
        is_old_activity,
        room_id: h_web_room_id,
        offset: 0,
        limit: 10,
        page_size: 10,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return _get(resp, 'data.data.list.0', {})
  }
)

export const gala_subscribe = createAsyncThunk(
  'PartyGala/gala_subscribe',
  async (params: any, store: any) => {
    const {from = ''} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/misc/gala_subscribe',
      {
        from,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const gala_summon = createAsyncThunk(
  'PartyGala/gala_summon',
  async (params: any, store: any) => {
    const {from = ''} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/misc/gala_summon',
      {
        from,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const gala_recap = createAsyncThunk(
  'PartyGala/gala_recap',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_recap',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const gala_apply = createAsyncThunk(
  'PartyGala/gala_apply',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_apply',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const apply_activity = createAsyncThunk(
  'PartyGala/apply_activity',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/apply_activity',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}
export const gala_reward_rules = createAsyncThunk(
  'PartyGala/gala_reward_rules',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_reward_rules',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const gala_cfg = createAsyncThunk(
  'PartyGala/gala_cfg',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/gala_cfg',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const batch_get_union_role = createAsyncThunk(
  'PartyGala/batch_get_union_role',
  async (params: any, store: any) => {
    const {h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/union/batch_get_union_role',
      {
        mids: [h_m],
        ...params,
      },
      {store, xcErrorToast: true}
    )
    const {role_map = {}, union_id_map = {}} = resp.data.data
    return {
      role: role_map[h_m],
      union_id: union_id_map[h_m],
    }
  }
)
const gala_rank = async (params: any, store: any) => {
  const resp = await http.post(
    '/live/misc/gala_rank',
    {
      ...params,
    },
    {store, xcErrorToast: true}
  )
  return resp.data.data
}
export const gala_rank_tab1 = createAsyncThunk(
  'PartyGala/gala_rank_tab1',
  (params: any, store: any) => gala_rank({type: 1}, store)
)
export const gala_rank_tab2 = createAsyncThunk(
  'PartyGala/gala_rank_tab2',
  (params: any, store: any) => gala_rank({type: 2}, store)
)

export interface InitialStateType {
  square: any
  rank: any
  rule: any
  conf: any
  recap: any
  detail: any
  pointInfo: any
}

const initialState: InitialStateType = {
  rank: {
    tab1: [],
    tab2: [],
    count_down: 0,
  },
  rule: {},
  square: {},
  conf: {},
  recap: {},
  detail: {},
  pointInfo: {},
}

export const PartyGalaSlice = createSlice({
  name: 'PartyGala',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(gala_rank_tab1.fulfilled, (state, action) => {
      const {list = [], count_down} = action.payload
      Object.assign(state.rank, {
        tab1: list,
        count_down,
      })
    })
    builder.addCase(gala_rank_tab2.fulfilled, (state, action) => {
      const {list = [], count_down} = action.payload
      Object.assign(state.rank, {
        tab2: list,
        count_down,
      })
    })
    builder.addCase(batch_get_union_role.fulfilled, (state, action) => {
      Object.assign(state.pointInfo, action.payload)
    })
    builder.addCase(gala_reward_rules.fulfilled, (state, action) => {
      Object.assign(state.rule, action.payload)
    })
    builder.addCase(gala_cfg.fulfilled, (state, action) => {
      Object.assign(state.conf, action.payload)
    })
    builder.addCase(gala_recap.fulfilled, (state, action) => {
      Object.assign(state.recap, action.payload)
    })
    builder.addCase(gala_detail.fulfilled, (state, action) => {
      Object.assign(state.detail, action.payload)
    })
  },
})
export default PartyGalaSlice.reducer
export const PartyGalaActions = PartyGalaSlice.actions

export const usePartyGalaState = () => {
  const data = useSelector((state) => {
    return state.PartyGala
  })
  return data
}
